import { createSelector } from 'reselect';
import { selectors as assetDetailsSelectors } from 'modules/api/asset/detailsModule';
import { selectors as productDetailsSelectors } from 'modules/api/product/detailsModule';
import { selectors as backupListSelectors } from 'modules/api/storm/backup/listModule';
import { cartDetailsSelectors } from 'modules/api/market/cart/detailsModule';
import { acronisProductCodes } from 'utility/acronisProductMap';

const getStateSlice = (state) => state.server.backupsAndImages.settings;

const isLoadingParent = createSelector(
	assetDetailsSelectors.isLoading,
	assetDetailsSelectors.acronisSelectors.isLoading,
	productDetailsSelectors.isLoading,
	productDetailsSelectors.acronisSelectors.isLoading,
	(assetDetails, assetDetailsAcronis, productDetails, productDetailsAcronis) =>
		assetDetails ||
		assetDetailsAcronis ||
		productDetails ||
		productDetailsAcronis,
);

const maxQuotaPlan = createSelector(
	productDetailsSelectors.quotaPlanOptions,
	(plans) =>
		Number(
			plans
				.sort(
					({ value: value1 }, { value: value2 }) =>
						Number(value1) - Number(value2),
				)
				.slice(-1)[0]?.value,
		),
);

const dataBarMarks = createSelector(
	productDetailsSelectors.quotaPlanOptions,
	maxQuotaPlan,
	getStateSlice,
	assetDetailsSelectors.backupQuotaValue,
	(plans, max, backupsSettingsSlice, currentQuota) => {
		const selected = Number(backupsSettingsSlice?.selectedQuota?.value || 0);
		const current = Number(currentQuota);
		return plans
			.filter(({ value }) => {
				return Number(value) < max;
			})
			.map(({ value }) => ({
				value: Number(value),
				disabled: (selected || current) <= Number(value),
			}));
	},
);

/** If one exists, gets the uuid of the current acronis product in the basket associated to the current server. */
const getAcronisInBasketUuid = createSelector(
	assetDetailsSelectors.uniqId,
	cartDetailsSelectors.getNativeItems,
	(serverId, cartItems) =>
		cartItems
			.filter((item) => acronisProductCodes.includes(item.code))
			.find((item) => item.details?.properties?.related_subaccnt === serverId)
			?.uuid,
);

const selectors = {
	getStateSlice,
	daysToRetain: createSelector(getStateSlice, (slice) => slice.daysToRetain),
	isLoading: createSelector(
		isLoadingParent,
		backupListSelectors.isLoading,
		(isLoadingP, backupList) => isLoadingP || backupList,
	),
	isLoadingParent,
	dataBarMarks,
	maxQuotaPlan,
	getAcronisInBasketUuid,
};
export default selectors;
